import visionXLogo from 'src/resources/images/vision-x-logo-single-2x.svg';

export const logo = (
  <img
    src={visionXLogo}
    className={'vx-logo-rect'}
    alt="Logo"
  />
);
